import React, {useState} from "react";
import { Modal } from "react-bootstrap";
import {Button, ProfilePicture} from "fearless-common-ui";
import {Group, User} from "fearless-common";
import UserCard from "../layout/UserCard";
import useGet from "../hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";

/**
 * Button to open a modal showing the users taking seats on the group.
 */
export default function ViewSeatHoldersModal({ groupId }: {  groupId: number }) {
  const [show, setShow] = useState(false);
  const { data: group } = useGet<Group & { users: User[] }>({
    endpoint: backendEndpoints.getGroup(groupId),
    params: { _with: ['users'] },
  });
  const users = group?.users.filter((u) => u?.subscription_per_product?.photo51?.group?.id === groupId) || [];
  const open = () => setShow(true);
  const hide = () => setShow(false);
  return (
    <>
      <Button onClick={open} className="text-xs" variant="link">View</Button>
      {show && (
        <Modal onHide={hide} show={show}>
          <Modal.Header closeButton>
            <Modal.Title>{group?.name} used seats</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-borderless mb-0">
              <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>
                    <div className="d-flex">
                      <ProfilePicture user={user} size="50px" />
                      <UserCard user={user} />
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={hide} variant="outline-primary">Close</Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
